export default "__VITE_ASSET___QZtQFHm__"